import { SignUpPage } from "./root";
import { ConfirmPage } from "./confirm";
import { SentPage } from "./sent";
import { WelcomePage } from "./welcome";
import { AccountConfirmedPage } from "./account-confirmed";
import { UserAccountConfirmedPage } from "./user-account-confirmed";

export type PageProps = { variant: "root" | "confirm" | "sent" | "welcome" | "account-confirmed" | "user-account-confirmed" };

export const Page = (props: PageProps): JSX.Element => {
  switch (props.variant) {
    case "root":
      return <SignUpPage />;
    case "confirm":
      return <ConfirmPage />;
    case "sent":
      return <SentPage />;
    case "welcome":
      return <WelcomePage />;
    case "account-confirmed":
      return <AccountConfirmedPage />;
    case "user-account-confirmed":
      return <UserAccountConfirmedPage />;
    default:
      throw new Error(`[SIGN UP ERROR]: Invalid variant provided`);
  }
};
